module.exports = __webpack_public_path__ + "static/media/HCMM079.9352cf8a.jpg";